import React, { useState, useEffect } from "react";
import {
  Form,
  Button,
  Space,
  Typography,
  Card,
  notification,
  Row,
  Col,
  Divider,
  Descriptions,
  Alert,
  Input,
  Checkbox,
  Select,
  Tag,
} from "antd";
import { ArrowLeftOutlined, FilePdfOutlined } from "@ant-design/icons";
import { getDetalleActaInicio } from "../../../services/visitas_tecnicas/getDetalleActaInicio";
import { useSelector } from "react-redux";
import insertVisita from "../../../services/visitas_tecnicas/postVisitasService";
import moment from "moment";
import "moment/locale/es";
import { insertLogApiRest } from "../../../services/logApiRest/postLogApiRestService";
import PdfAlmacenarActaInicio from "./Acta_inicio_pdf_almacenar";
import { pdf } from "@react-pdf/renderer";
import getVisitaPorTipoAndCodigo from "../../../services/visitas_tecnicas/getVisitaPorTipoAndCodigoService";
import { postSoportePatti } from "../../../services/visitas_tecnicas/postAlmacenarSoportePatti";

const { Title, Text, Paragraph } = Typography;
const { Option } = Select;

const tagStyle = {
  color: "#145BAD",
  fontSize: "15px",
  fontWeight: "bold",
  padding: "8px 15px",
  borderRadius: "8px",
  textAlign: "left",
  display: "block",
  marginBottom: "15px",
  marginTop: "20px",
  width: "100%",
  wordWrap: "break-word", // Asegura que el texto se divida en múltiples líneas
  wordBreak: "break-word", // Rompe palabras largas que no caben
  whiteSpace: "normal", // Permite que el texto se ajuste en varias líneas
};

const FormularioActaInicio = ({
  initialData,
  actionVolver,
  tipoVisita,
  estado_formulario,
  fetchDataLocal,
  rolAcces = "tecnico",
  fetchVisitaTecnica_locales,
}) => {
  const [form] = Form.useForm();
  const [formData, setFormData] = useState(initialData);
  const [loading, setLoading] = useState(true);
  const [firmaData, setFirmaData] = useState(null);
  const [firmaTecnicoData, setFirmaTecnicoData] = useState(null);
  const usernameFromState = useSelector((state) => state.auth.user);
  const [mostrarMensajeFirma, setMostrarMensajeFirma] = useState(false);

  // Inicializamos el estado con los valores de moment
  const [fechaActual, setFechaActual] = useState({
    dia: moment().format("D"),
    mes: moment().locale("es").format("MMMM"),
    año: moment().format("YYYY"),
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (estado_formulario === 0) {
          const data = await getDetalleActaInicio(formData.id_participante);

          setFormData(data.detalle);
          cargarFirma(data.detalle.firma_participante, "participante");
          cargarFirma(data.detalle.firma_tecnico, "tecnico");


          form.setFieldsValue({
            dia: fechaActual.dia,
            mes: fechaActual.mes,
            vigencia: fechaActual.año,
          });
        } else {
          if (rolAcces === "tecnico") {
            setMostrarMensajeFirma(false);
          } else {
            if (initialData.aprobacionARN === true) {
              setMostrarMensajeFirma(false);
            } else {
              setMostrarMensajeFirma(true);
            }
          }

          const data = await getDetalleActaInicio(formData.id_participante);
          const datosCompletos = {
            ...data.detalle,
          };

          setFormData(datosCompletos);
          form.setFieldsValue({
            nombreProfesionalARN: usernameFromState.name,
            dia: initialData.dia,
            mes: initialData.mes,
            vigencia: initialData.vigencia,
            ciudad: initialData.ciudad,
          });
          cargarFirma(data.detalle.firma_participante, "participante");
          cargarFirma(data.detalle.firma_tecnico, "tecnico");
        }
      } catch (error) {
        notification.error({
          message: "Error",
          description: "Error al cargar los datos del acta: " + error.message,
        });
      } finally {
        setLoading(false);
      }
    };

    // Solo establecer la fecha actual si no hay una fecha existente en el formulario
    const fechaExistente = form.getFieldValue("fecha_registro");
    if (!fechaExistente) {
      const fechaActual = new Date().toISOString().split("T")[0];
      form.setFieldsValue({ fecha_registro: fechaActual });
    }
    fetchData();
  }, []);

  const cargarFirma = async (ruta, tipoFirma) => {
    if (ruta) {
      if (tipoFirma === "participante") {
        setFirmaData(ruta);
      } else if (tipoFirma === "tecnico") {
        setFirmaTecnicoData(ruta);
      }
    }
  };

  const obtenerDatosCompletosActaInicio = async (formData) => {
    try {
      const detalle = await getDetalleActaInicio(formData.id_participante);
      if (detalle?.success) {
        return detalle.detalle;
      } else {
        return formData;
      }
    } catch (error) {
      console.error("Error al obtener datos del diagnóstico:", error);
      return formData; // fallback
    }
  };

  const enviarPDFAlServidor = async (data, id, nombreTipo) => {
    try {
      let datosCompletos = await obtenerDatosCompletosActaInicio(data.detalle);

      let blob = await pdf(
        <PdfAlmacenarActaInicio formData={datosCompletos} />
      ).toBlob();

      const nombreArchivo = `${id}_${nombreTipo}_${data.fecha_archivo}.pdf`;

      const formDataToSend = new FormData();
      formDataToSend.append(
        "ruta",
        `${data.fecha_directorio}/${data.departamento}/${data.codigo_pre}/`
      );
      formDataToSend.append("nombre_archivo", nombreArchivo);
      formDataToSend.append("file", blob, nombreArchivo);

      const response = await postSoportePatti(formDataToSend, data.id);
      return response;
    } catch (err) {
      console.error("❌ Error al enviar el PDF:", err);
    }
  };

  const almacenarInformacion = async (newFormData) => {
    try {
      if (estado_formulario == 1) {
        const respuesta = await insertVisita(newFormData);

        if (!respuesta) {
          notification.error({
            message: "Error",
            description: "Error al guardar información",
          });
          return false;
        }

        // Obtener datos de la visita para generar el PDF
        const response = await getVisitaPorTipoAndCodigo(
          initialData.id_participante,
          5
        );

        if (!response) {
          console.error("No se pudo obtener detalle");
          notification.error({
            message: "Error",
            description:
              "No se pudo obtener el detalle de la visita para el PDF.",
          });
          return false;
        }

        const respuestaPDF = await enviarPDFAlServidor(
          response,
          5,
          "Acta_inicio"
        );

        if (respuestaPDF.status === 200) {
          notification.success({
            message: "Registro exitoso",
            description:
              "Se ha almacenado correctamente el registro en el sistema.",
          });
        } else {
          notification.error({
            message: "Error al subir PDF",
            description:
              "El registro se guardó correctamente, pero hubo un problema al generar o subir el archivo PDF.",
          });
          return false;
        }
      } else {
        // Registrar el log
        const respuestaLog = await insertLogApiRest(
          newFormData,
          "/api/insertVisita"
        );
        if (!respuestaLog?.success) {
          notification.error({
            message: "Error en el log",
            description:
              respuestaLog?.message ||
              "No se pudo registrar la acción en el sistema.",
          });
          setLoading(false);
          return; // Detiene la ejecución
        }
        const respuesta = await insertVisita(newFormData);

        if (!respuesta) {
          notification.error({
            message: "Error",
            description: "Error al guardar información",
          });
          return false;
        }

        if (newFormData?.estado_formulario === 1) {
          // Obtener datos de la visita para generar el PDF
          const response = await getVisitaPorTipoAndCodigo(
            initialData.id_participante,
            5
          );

          if (!response) {
            console.error("No se pudo obtener detalle");
            notification.error({
              message: "Error",
              description:
                "No se pudo obtener el detalle de la visita para el PDF.",
            });
            return false;
          }

          const respuestaPDF = await enviarPDFAlServidor(
            response,
            5,
            "Acta_inicio"
          );

          if (respuestaPDF.status === 200) {
            notification.success({
              message: "Registro exitoso",
              description:
                "Se ha almacenado correctamente el registro en el sistema.",
            });
          } else {
            notification.error({
              message: "Error al subir PDF",
              description:
                "El registro se guardó correctamente, pero hubo un problema al generar o subir el archivo PDF.",
            });
            return false;
          }

          return true;
        } else {
          notification.success({
            message: "Registro exitoso",
            description:
              "Se ha almacenado correctamente el registro en el sistema.",
          });
          return true;
        }
      }
    } catch (error) {
      console.error("Error en guardarEstado:", error);
      notification.error({
        message: "Error",
        description: "Error inesperado al guardar información.",
      });
      return false;
    }
  };

  const onFinish = async (values) => {
    try {
      // Generar el nombre de la imagen para la firma

      let data = {}; // Cambié 'const' por 'let' para poder reasignar

      // Ingresamos como técnicos
      if (estado_formulario === 0) {
        data = {
          detalle: {
            ...values,
            id_participante: initialData.id_participante,
            user_email: usernameFromState.email,
            fuente: "Web",
            aprobacionARN: false,
          },
          tipo_visita: tipoVisita,
          estado_formulario: 1,
          user: usernameFromState.email,
        };

        // Ingresamos con representantes de ARN
      } else {
        data = {
          detalle: {
            ...initialData,
            user_email_arn: usernameFromState.email,
            fuente: "Web",
            aprobacionARN: true,
          },
          tipo_visita: tipoVisita,
          estado_formulario: 1,
          user: usernameFromState.email,
        };
      }

      // 🔹 Insertamos la visita solo si el log fue exitoso

      const result = await almacenarInformacion(data);
      if (result) {
        if (rolAcces !== "tecnico") {
          fetchVisitaTecnica_locales(tipoVisita, initialData.id_participante);
        }

        fetchDataLocal(tipoVisita, initialData.id_participante);
        actionVolver();
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "Error al procesar la solicitud: " + error.message,
      });
    }
  };

  return (
    <div
      className="form-container"
      style={{
        padding: "10px",
        backgroundColor: "#f0f2f5",
        margin: "0 auto",
        maxWidth: "100%",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      {loading ? (
        <Card loading={true} />
      ) : formData ? (
        <Form
          form={form}
          onFinish={onFinish}
          layout="vertical"
          onFinishFailed={(errorInfo) => {
            console.error("Falló la validación del formulario:", errorInfo);
          }}
        >
          <Row
            justify="space-between"
            align="middle"
            style={{ marginBottom: 24 }}
          >
            <Col Col xs={24} md={12} lg={4}>
              <Button
                type="primary"
                icon={<ArrowLeftOutlined />}
                onClick={actionVolver}
                ghost
              >
                Volver
              </Button>
            </Col>

            <Col Col xs={24} md={12} lg={20} style={{ marginTop: "24px" }}>
              {/* Título Principal */}
              <Title
                level={3}
                style={{
                  textAlign: "center",
                  marginBottom: 32,
                  fontWeight: "bold",
                }}
              >
                ACTA DE INICIO DE ASISTENCIA TÉCNICA PARA PROYECTOS PRODUCTIVOS
              </Title>
            </Col>
          </Row>

          <Row gutter={[16, 16]} style={{ marginTop: "24px" }}>
            <Col xs={8} md={8} lg={8}>
              <Text type="secondary">CÓDIGO: IR-F-111</Text>
              <Divider type="vertical" />
            </Col>
            <Col xs={8} md={8} lg={8}>
              <Text type="secondary">FECHA: 22021-08-10</Text>
              <Divider type="vertical" />
            </Col>

            <Col xs={8} md={8} lg={8}>
              <Text type="secondary">VERSIÓN: V-2</Text>
            </Col>
          </Row>

          <Row gutter={[16, 16]} style={{ marginTop: "24px" }}>
            <Col xs={24} md={24} lg={24}>
              {/* Header */}
              <Tag color="#D0E0F2" style={tagStyle}>
                1. IDENTIFICACIÓN DEL PROYECTO PRODUCTIVO
              </Tag>
            </Col>
            <Col xs={24} md={24} lg={24}>
              <Descriptions
                style={{ marginTop: "24px" }}
                bordered
                column={{ xxl: 2, xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }}
              >
                <Descriptions.Item label="Fecha">
                  {formData.fecha_registro}
                </Descriptions.Item>
                <Descriptions.Item label="Nombre del proyecto productivo">
                  {formData.nombre_proyecto}
                </Descriptions.Item>
                <Descriptions.Item label="Nombre de la forma Asociativa">
                  {formData.asociativo_individual}
                </Descriptions.Item>
                <Descriptions.Item label="Código del proyecto PRE-PP">
                  {formData.codigo_pre}
                </Descriptions.Item>
                <Descriptions.Item label="Número de personas en reincorporación">
                  {formData.total_participantes}
                </Descriptions.Item>
              </Descriptions>

              <Divider orientation="left">Ubicación del proyecto</Divider>

              <Descriptions
                bordered
                column={{ xxl: 3, xl: 3, lg: 2, md: 1, sm: 1, xs: 1 }}
              >
                <Descriptions.Item label="Departamento">
                  {formData.departamento}
                </Descriptions.Item>
                <Descriptions.Item label="Municipio">
                  {formData.municipio}
                </Descriptions.Item>
                <Descriptions.Item label="Vereda">
                  {formData.direccion_proyecto}
                </Descriptions.Item>
                <Descriptions.Item label="Acompañamiento y asistencia técnica por">
                  {estado_formulario == 0
                    ? usernameFromState.name
                    : formData.name_tecnico}
                </Descriptions.Item>
              </Descriptions>

              <Divider orientation="left">Detalles del proyecto</Divider>

              <Descriptions bordered column={1}>
                <Descriptions.Item label="Objetivo General del Proyecto">
                  Fortalecer los procesos de reincorporación económica y social
                  a personas en proceso de reincorporación con asistencia
                  técnica integral para los proyectos productivos individuales e
                  individuales asociativos
                </Descriptions.Item>
                <Descriptions.Item label="Descripción del Proyecto">
                  {formData.descripcion}
                </Descriptions.Item>
              </Descriptions>
            </Col>
          </Row>

          {/* Sección para proyectos individuales */}

          <Row gutter={[16, 16]} style={{ marginTop: "24px" }}>
            <Col xs={24} md={24} lg={24}>
              <Tag color="#D0E0F2" style={tagStyle}>
                ESPACIO EXCLUSIVO PARA PROYECTOS INDIVIDUALES
              </Tag>
            </Col>

            <Col xs={24} md={24} lg={24}>
              <Paragraph
                style={{
                  textAlign: "justify",
                  marginBottom: "16px",
                  paddingLeft: "24px",
                  paddingRight: "24px",
                }}
              >
                {formData.nombre_participante}, identificado(a) con CC, N°{" "}
                {formData.codigo_sir}, en calidad de beneficiario(a) del apoyo
                económico, debidamente acreditado(a) por la OACP, y la Agencia
                para la Reincorporación y la Normalización - ARN, representada
                por{" "}
                {rolAcces === "tecnico" ? (
                  <>______</>
                ) : (
                  <Form.Item
                    name="nombreProfesionalARN"
                    style={{ display: "inline-block", margin: "0 8px" }}
                  >
                    <Input
                      placeholder={"Nombre del representante de ARN"}
                      style={{ width: "200px" }}
                      disabled
                    />
                  </Form.Item>
                )}
                , delegado por la {formData.grupoTerritorial}, expresan su
                voluntad de dar inicio a partir de la suscripción de la presente
                acta a la ejecución de la asistencia técnica para el proyecto
                productivo antes citado y el interés de participar en todo el
                proceso.
              </Paragraph>
            </Col>
          </Row>

          {/* Sección de Acuerdo de Compromiso */}

          <Row gutter={[16, 16]} style={{ marginTop: "24px" }}>
            <Col xs={24} md={24} lg={24}>
              <Tag color="#D0E0F2" style={tagStyle}>
                ACUERDO DE COMPROMISO
              </Tag>
            </Col>

            <Col xs={24} md={24} lg={24}>
              <Paragraph
                style={{
                  textAlign: "justify",
                  marginBottom: "16px",
                  fontSize: "16px",
                  color: "#262626",
                  paddingLeft: "24px",
                  paddingRight: "24px",
                }}
              >
                En constancia de lo anterior se suscribe la presente el día{" "}
                <Form.Item
                  name="dia"
                  noStyle
                  rules={[
                    estado_formulario === 0 && {
                      required: true,
                      message: "El día es requerido",
                    },
                  ].filter(Boolean)} // Remueve valores falsos
                >
                  <Select
                    disabled={estado_formulario === 1}
                    placeholder="Día"
                    style={{ width: "60px" }}
                  >
                    {Array.from({ length: 31 }, (_, i) => (
                      <Option key={i + 1} value={i + 1}>
                        {i + 1}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>{" "}
                del mes{" "}
                <Form.Item
                  name="mes"
                  noStyle
                  rules={[
                    estado_formulario === 0 && {
                      required: true,
                      message: "El mes es requerido",
                    },
                  ].filter(Boolean)} // Remueve valores falsos
                >
                  <Select
                    disabled={estado_formulario === 1}
                    placeholder="Mes"
                    showSearch
                    optionFilterProp="children"
                    style={{ width: "100px" }}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {[
                      "Enero",
                      "Febrero",
                      "Marzo",
                      "Abril",
                      "Mayo",
                      "Junio",
                      "Julio",
                      "Agosto",
                      "Septiembre",
                      "Octubre",
                      "Noviembre",
                      "Diciembre",
                    ].map((mes, index) => (
                      <Option key={index} value={mes}>
                        {mes}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>{" "}
                del año{" "}
                <Form.Item
                  name="vigencia"
                  noStyle
                  rules={[
                    estado_formulario === 0 && {
                      required: true,
                      message: "El año es requerido",
                    },
                  ].filter(Boolean)} // Remueve valores falsos
                >
                  <Select
                    disabled={estado_formulario === 1}
                    placeholder="Año"
                    style={{ width: "80px" }}
                  >
                    {Array.from({ length: 5 }, (_, i) => (
                      <Option key={2024 + i} value={2024 + i}>
                        {2024 + i}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>{" "}
                en la ciudad{" "}
                <Form.Item
                  name="ciudad"
                  noStyle
                  rules={[
                    estado_formulario === 0 && {
                      required: true,
                      message: "La ciudad es requerido",
                    },
                  ].filter(Boolean)} // Remueve valores falsos
                >
                  <Input
                    disabled={estado_formulario === 1}
                    placeholder="Ciudad"
                    style={{ width: "300px" }}
                  />
                </Form.Item>
                .
              </Paragraph>
            </Col>
          </Row>
          {/* Sección de solo visualización para participante */}
          <Row gutter={[24, 24]} style={{ marginTop: "24px" }}>
            <Col xs={24} md={12}>
              <div
                style={{
                  border: "1px solid #f0f0f0",
                  borderRadius: "8px",
                  backgroundColor: "#fff",
                  boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                }}
              >
                {/* Título de la sección */}
                <div
                  style={{
                    borderBottom: "1px solid #f0f0f0",
                    padding: "12px 20px",
                    backgroundColor: "#fafafa",
                    borderTopLeftRadius: "8px",
                    borderTopRightRadius: "8px",
                  }}
                >
                  <Text strong style={{ color: "#1890ff" }}>
                    Firma del participante legal{" "}
                    {formData &&
                      formData.tipo_autorizacion === "Firma por Testigo" &&
                      "(Firma  por testigo)"}
                  </Text>
                </div>

                {/* Área de visualización de firma */}
                <div
                  style={{
                    padding: "20px",
                    backgroundColor: "#fff",
                  }}
                >
                  <div
                    style={{
                      border: "1px solid #d9d9d9",
                      borderRadius: "4px",
                      padding: "15px",
                      backgroundColor: "#fafafa",
                      minHeight: "150px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {firmaData ? (
                      <>
                        {formData.tipo_autorizacion === "Firma Electrónica" ||
                          formData.tipo_autorizacion === "Firma por Testigo" ? (
                          <img
                            src={firmaData}
                            alt="Firma del participante"
                            style={{
                              maxWidth: "100%",
                              maxHeight: "150px",
                              marginBottom: "15px",
                            }}
                          />
                        ) : (
                          <audio
                            controls
                            src={firmaData}
                            style={{ width: "100%" }}
                          >
                            Tu navegador no soporta el elemento de audio.
                          </audio>
                        )}
                        <Text
                          strong
                          style={{ fontSize: "14px", textAlign: "left" }}
                        >
                          Nombre:{" "}
                          {formData.tipo_autorizacion === "Firma por Testigo"
                            ? formData.nombre_testigo || ""
                            : formData.nombre_participante || ""}
                        </Text>

                        <Text
                          strong
                          style={{ fontSize: "14px", textAlign: "left" }}
                        >
                          {formData.tipo_autorizacion === "Firma por Testigo"
                            ? "Cédula"
                            : "Código SIR"}
                          :{" "}
                          {formData.tipo_autorizacion === "Firma por Testigo"
                            ? formData.cedula_testigo || ""
                            : formData.codigo_sir || ""}
                        </Text>
                      </>
                    ) : (
                      <Text type="secondary" style={{ fontSize: "14px" }}>
                        Pendiente de firma
                      </Text>
                    )}
                  </div>
                </div>
              </div>
            </Col>

            <Col xs={24} md={12}>
              <div
                style={{
                  border: "1px solid #f0f0f0",
                  borderRadius: "8px",
                  backgroundColor: "#fff",
                  boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                }}
              >
                {/* Título de la sección */}
                <div
                  style={{
                    borderBottom: "1px solid #f0f0f0",
                    padding: "12px 20px",
                    backgroundColor: "#fafafa",
                    borderTopLeftRadius: "8px",
                    borderTopRightRadius: "8px",
                  }}
                >
                  <Text strong style={{ color: "#1890ff" }}>
                    Firma del representante de la Organización del
                    acompañamiento y la asistencia técnica:
                  </Text>
                </div>

                {/* Área de visualización de firma */}
                <div
                  style={{
                    padding: "20px",
                    backgroundColor: "#fff",
                  }}
                >
                  <div
                    style={{
                      border: "1px solid #d9d9d9",
                      borderRadius: "4px",
                      padding: "15px",
                      backgroundColor: "#fafafa",
                      minHeight: "150px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {firmaTecnicoData ? (
                      <>
                        <img
                          src={firmaTecnicoData}
                          alt="Firma del técnico"
                          style={{
                            maxWidth: "100%",
                            maxHeight: "150px",
                            marginBottom: "15px",
                          }}
                        />
                        <Text
                          strong
                          style={{ fontSize: "14px", textAlign: "left" }}
                        >
                          Nombre: {formData.name_tecnico_analisis || ""}
                        </Text>

                        <Text
                          strong
                          style={{ fontSize: "14px", textAlign: "left" }}
                        >
                          Cargo : {formData.cargo_tecnico_analisis || ""}
                        </Text>
                      </>
                    ) : (
                      <Text type="secondary" style={{ fontSize: "14px" }}>
                        Pendiente de firma
                      </Text>
                    )}
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          {estado_formulario === 1 && rolAcces !== "tecnico" && (
            <Row gutter={[24, 24]}>
              {/* Columna para la firma */}
              <Col xs={24} md={24}>
                <div
                  style={{
                    border: "1px solid #f0f0f0",
                    borderRadius: "8px",
                    backgroundColor: "#fff",
                    boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                  }}
                >
                  <div
                    style={{
                      borderBottom: "1px solid #f0f0f0",
                      padding: "12px 20px",
                      backgroundColor: "#fafafa",
                      borderTopLeftRadius: "8px",
                      borderTopRightRadius: "8px",
                    }}
                  >
                    <Text strong style={{ color: "#1890ff" }}>
                      Firma por representante de ARN:
                    </Text>
                  </div>

                  <div style={{ padding: "20px" }}>
                    <Space direction="vertical" style={{ width: "100%" }}>
                      {initialData.aprobacionARN === true ? (
                        <img
                          src={formData.picture}
                          alt="Firma del representante de arn"
                          style={{
                            maxWidth: "100%",
                            maxHeight: "150px",
                            marginBottom: "15px",
                          }}
                        />
                      ) : (
                        mostrarMensajeFirma && (
                          <Alert
                            message="Aviso Importante sobre Firma Digital"
                            description={
                              <div>
                                <p>
                                  Al hacer clic en "Validar Acta", su firma
                                  digital registrada será utilizada como
                                  constancia oficial de aprobación en este
                                  documento.
                                </p>
                                <p>
                                  Esta acción no se puede deshacer una vez
                                  confirmada.
                                </p>
                              </div>
                            }
                            type="warning"
                            showIcon
                            style={{
                              marginTop: "10px",
                              backgroundColor: "#fffbe6",
                              border: "1px solid #ffe58f",
                            }}
                          />
                        )
                      )}
                    </Space>
                  </div>
                </div>
              </Col>
            </Row>
          )}
          <div style={{ marginTop: "20px", textAlign: "center" }}>
            <Form.Item>
              {rolAcces === "tecnico" ? (
                estado_formulario === 1 ? (
                  initialData.aprobacionARN === true ? (
                    <Alert
                      message="Validación Completa"
                      description="El acta ha sido validada por ARN"
                      type="success"
                      showIcon
                    />
                  ) : (
                    <Alert
                      message="En Proceso de Validación"
                      description="El acta ha sido enviada a validación a ARN"
                      type="info"
                      showIcon
                    />
                  )
                ) : (
                  <Button type="primary" htmlType="submit">
                    Enviar a validación ARN
                  </Button>
                )
              ) : estado_formulario === 1 &&
                initialData.aprobacionARN === true ? (
                <Alert
                  message="Validación Completa"
                  description="El acta ha sido validada por ARN"
                  type="success"
                  showIcon
                />
              ) : (
                <Button type="primary" htmlType="submit">
                  Validar Acta
                </Button>
              )}
            </Form.Item>
          </div>
        </Form>
      ) : (
        <Alert
          message="Error"
          description="No se pudieron cargar los datos del acta"
          type="error"
          showIcon
        />
      )}
    </div>
  );
};

export default FormularioActaInicio;
